<template>
  <div class="summer-container">
    <div class="banner">心系工程 追求更好</div>

    <div class="main">
      <!-- 主体内容 -->
      <div class="content">
        <template v-if="isAllowed">
          <p style="padding: 20px;font-size: 20px;font-family: fangsong;">夏令营的申请只需要补充完善好个人基本资料信息后，点击“立即申请”即可。</p>

          <div style="width: 300px;text-align: center;margin-top: 50px;float: right;">
            <ghidri-button @click="submit" size="large" :type="typeFilter">{{ submitBarText }}</ghidri-button>
          </div>
        </template>
        <template v-else>
          <p style="padding: 20px;font-size: 20px;text-align: center;font-family: fangsong;">您已经申请过今年的夏令营计划，无需再次申请！</p>

          <div style="width: 500px;text-align: center;margin-top: 50px;margin: 0 auto;">
            <ghidri-button @click="applyHistory" size="large">去查看我的申请记录</ghidri-button>
          </div>
        </template>
      </div>
    </div>

    <el-dialog
      title="是否确认申请？"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <div class="content">
        <p style="padding: 0 20px;">请确认基本资料已经完善，这样有助于HR多方位了解你，提高求职成功的几率！</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" icon="el-icon-check" @click="onAddClicked">确认申请</el-button>
      </span>
    </el-dialog>

    <el-backtop :bottom="100"></el-backtop>
  </div>
</template>

<script>
  import summerOrderApi from "@/api/summer/summerOrder.js";

  import store from "@/store/index.js";

  export default {
    name: "Summer",
    data() {
      return {
        dialogVisible: false,

        isAllowed: false //是否允许申请
      };
    },
    computed: {
      isComplete() {  // 个人资料是否完善
        return this.userInfo && this.userInfo.isComplete;
      },
      userInfo() {
        return store.getters.user;
      },
      categoryTimeId() {
        const categoryTimeList = store.getters.categoryTimeList;
        for (var i = 0; i < categoryTimeList.length; i++) {
          if (store.getters.category.summer == categoryTimeList[i].categoryCode) {
            return categoryTimeList[i].id;
          }
        }
        return "";
      },
      submitBarText() {
        if (this.isComplete) {
          return "立即申请";
        }
        return "去完善个人信息";
      },
      typeFilter() {
        if (this.isComplete) {
          return "default";
        }
        return "danger";
      }
    },
    created() {
      this.prepareCheckout()
    },
    methods: {
      prepareCheckout() {
        const _this = this;
        summerOrderApi.prepareCheckout(_this.categoryTimeId).then(res => {
          _this.isAllowed = res.data;
        }).catch(err => {
          console.error("err", err);
        });
      },
      submit() {
        const _this = this;
        if (!_this.isComplete) {  //  用户信息不存在，则引导用户去完善
          _this.$router.push({
            path: "/resume/edit?redirect=" + this.$route.path
          });
          return;
        }
        _this.dialogVisible = true;
      },
      applyHistory() {
        this.$router.push({
          path: "/apply"
        });
      },
      onAddClicked() {
        const _this = this;
        summerOrderApi.save(_this.categoryTimeId).then(res => {
          _this.dialogVisible = false;
          _this.$router.push({ path: "success" });
        }).catch(err => {
          console.error("err", err);
          _this.dialogVisible = false;
          _this.$message.error(err || "网络出错，请稍后再试");
        });
      },
      handleClose(done) {
        this.dialogVisible = false;
        done();
      }
    }
  };
</script>

<style lang="less" scoped>
  .summer-container {
    .banner {
      height: 400px;
      line-height: 400px;
      color: #fff;
      width: 100%;
      min-width: @main-width;
      background-image: url("/img/buss/wind.png");
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      text-align: center;
      font-size: @font-size-larger;
    }

    .main {
      width: 100%;
      margin-top: 100px;
      padding: 0 200px;

      .content {
        min-height: 500px;
        border-left: 1px solid @border-lighter-color;
        border-right: 1px solid @border-lighter-color;

        .pagination-wrapper {
          margin-top: 10px;
          text-align: right;
        }
      }
    }
  }

</style>
